@if (show) {
  <div>
    <div class="loader-overlay">
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
  </div>
}
